/**
 * Mixin um Pixel zu REM zu konvertieren
 * @param values Beliebige Anzahl von Zahlen
 * @example
 *     padding: ${remCalc(5, 20, 0)}; ===> padding: 0.3125rem 1.25rem 0;
 */
export const remCalc = (...values: Array<number>) =>
    values.map(value => (value === 0 ? `0` : `${value / 16}rem`)).join(` `);
